import axios, { AxiosResponse } from 'axios';

const url = 'https://pbf.qoldau.kz';

export const getPbfToken = (): Promise<AxiosResponse> => {
    return axios.post(
        `${url}/Authentication/GetAccessToken`,
        JSON.stringify({
            accessId: 'eb93b433-73ff-4272-9c99-ad659893509b',
        }),
        {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
            },
        }
    );
};

//?clientRecaptchaResponse=${token}
export const getUkmInfo = (request: any): Promise<AxiosResponse> => {
    return axios.get(`${url}/Checker/CheckCode`, {
        params: request,
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            // Authorization: `Bearer ${token}`,
        },
    });
};
